import { AdditionalSupplyChainActor } from 'features/declaration/additional-supply-chain-actor/models/schema'
import {
  NotesDocument, PreviousDocument, SupportingDocument, TransportDocument,
} from 'features/declaration/models/schemas/documentSchemas'
import {
  ActiveBorderTransportMeansType,
  AdditionalInformationType,
  AdditionalReferenceFormValues,
  AddressFormValues,
  AuthorisationFormValues,
  ContactPerson,
  CountriesOfRoutingType,
  CustomsOfficeOfExitForTransitDeclared,
  CustomsOfficeOfTransitDeclared,
  DepartureTransportMeansType,
  GoodsReferenceType,
  PassiveBorderTransportMeansType,
  SealType,
  TransportEquipmentType,
} from 'features/declaration/models/schemas/commonConsignmentSchemas'
import {
  AmountUnit, ConsignmentItemFormValues, DangerousGoodsType, PackagingType,
} from 'features/declaration/consignment-item/models/schema'
import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import {
  BuyerFormValues, CarrierFormValues, ConsigneeFormValues, ConsignorFormValues, Declarant, SellerFormValues,
} from 'features/declaration/models/schemas/tradersSchema'
import { LocationOfGoodsType } from 'features/declaration/models/schemas/locationOfGoodsSchema'
import {
  PlaceOfAcceptance, PlaceOfDelivery, PlaceOfLoading, PlaceOfUnloading,
} from 'features/declaration/models/schemas/placesSchemas'
import { GuaranteeFormValues } from 'features/declaration/models/schemas/guaranteeSchema'

export const blankTransportDocument: TransportDocument = {
  id: null,
  type: 'TRANSPORT',
  sequenceNumber: 0,
  documentType: '',
  files: [],
  referenceNumber: '',
}
export const blankCustomsOfficeOfTransitDeclared: CustomsOfficeOfTransitDeclared = {
  id: null,
  sequenceNumber: 0,
  arrivalDateAndTime: '',
  referenceNumber: '',
  entryIndicator: 'false',
  reEntryIndicator: 'false',
}
export const blankCustomsOfficeOfExitForTransitDeclared: CustomsOfficeOfExitForTransitDeclared = {
  id: null,
  sequenceNumber: 0,
  referenceNumber: '',
}
export const blankActiveBorderTransportMeans: ActiveBorderTransportMeansType = {
  id: null,
  sequenceNumber: 0,
  customsOfficeAtBorderReferenceNumber: '',
  typeOfIdentification: '',
  typeOfMeansOfTransport: '',
  identificationNumber: '',
  nationality: '',
  conveyanceReferenceNumber: '',
  actualDateAndTimeOfDeparture: '',
  estimatedDateAndTimeOfDeparture: '',
  estimatedDateAndTimeOfArrival: '',
  countriesOfRouting: [],
}
export const blankPassiveBorderTransportMeans: PassiveBorderTransportMeansType = {
  id: null,
  sequenceNumber: 0,
  identificationNumber: '',
  typeOfIdentification: '',
  typeOfMeansOfTransport: '',
  nationality: '',
}
export const blankAdditionalInformation: AdditionalInformationType = {
  id: null,
  sequenceNumber: 0,
  code: '',
  text: '',
}
export const blankAdditionalReference: AdditionalReferenceFormValues = {
  id: null,
  sequenceNumber: 0,
  type: '',
  referenceNumber: '',
}
export const blankAdditionalSupplyChainActor: AdditionalSupplyChainActor = {
  id: null,
  sequenceNumber: 0,
  role: '',
  identificationNumber: '',
}

export const blankAddress: AddressFormValues = {
  city: '',
  country: '',
  id: null,
  postcode: '',
  addressLine: '',
  street: '',
  streetNumber: '',
}

export const blankCarrier: CarrierFormValues = {
  deleted: false,
  id: null,
  name: '',
  identificationNumber: '',
  target: 'CARRIER' as const,
  address: blankAddress,
  contactPerson: {
    id: null,
    deleted: false,
    name: '',
    email: '',
    telephone: '',
  },
}

export const blankContactPerson: ContactPerson = {
  id: null,
  deleted: false,
  name: '',
  email: '',
  telephone: '',
}

export const blankConsignor: ConsignorFormValues = {
  deleted: false,
  id: null,
  identificationNumber: '',
  name: '',
  target: 'CONSIGNOR' as const,
  address: blankAddress,
  contactPerson: blankContactPerson,
}

export const blankConsignee: ConsigneeFormValues = {
  id: null,
  deleted: false,
  identificationNumber: '',
  name: '',
  target: 'CONSIGNEE' as const,
  address: blankAddress,
  contactPerson: blankContactPerson,
}

export const blankDeclarant: Declarant = {
  id: null,
  deleted: false,
  identificationNumber: '',
  name: '',
  target: 'DECLARANT' as const,
  address: blankAddress,
}

export const blankBuyer: BuyerFormValues = {
  id: null,
  deleted: false,
  identificationNumber: '',
  name: '',
  typeOfPerson: '',
  target: 'BUYER' as const,
  address: {
    id: null,
    city: '',
    country: '',
    postcode: '',
    addressLine: '',
    streetNumber: '',
  },
  contactPerson: {
    id: null,
    deleted: false,
    name: '',
    email: '',
    telephone: '',
  },
}

export const blankSeller: SellerFormValues = {
  id: null,
  deleted: false,
  identificationNumber: '',
  name: '',
  typeOfPerson: '',
  target: 'SELLER' as const,
  address: {
    id: null,
    city: '',
    country: '',
    postcode: '',
    addressLine: '',
    streetNumber: '',
  },
  contactPerson: {
    id: null,
    deleted: false,
    name: '',
    email: '',
    telephone: '',
  },
}

export const blankLocationOfGoods: LocationOfGoodsType = {
  id: null,
  deleted: false,
  typeOfLocation: '',
  qualifierOfIdentification: '',
  authorisationNumber: '',
  additionalIdentifier: '',
  unLocode: '',
  referenceNumber: '',
  economicOperatorIdentificationNumber: '',
  postcodeAddress: {
    postcode: '',
    houseNumber: '',
    country: '',
  },
  gnss: null,
  address: blankAddress,
  contactPerson: null,
}
export const blankPlaceOfLoading: PlaceOfLoading = {
  id: null,
  unLocode: '',
  country: '',
  location: '',
  type: 'LOADING' as const,
  deleted: false,
}
export const blankPlaceOfUnloading: PlaceOfUnloading = {
  id: null,
  unLocode: '',
  country: '',
  location: '',
  type: 'UNLOADING' as const,
  deleted: false,
}

export const blankPlaceOfAcceptance: PlaceOfAcceptance = {
  id: null,
  unLocode: '',
  country: '',
  location: '',
  type: 'ACCEPTANCE' as const,
  deleted: false,
}

export const blankPlaceOfDelivery: PlaceOfDelivery = {
  id: null,
  unLocode: '',
  country: '',
  location: '',
  type: 'DELIVERY' as const,
  deleted: false,
}

export const blankPackaging: PackagingType = {
  id: null,
  sequenceNumber: 0,
  typeOfPackages: '',
  numberOfPackages: null,
  shippingMarks: '',
  deleted: false,
}

export const blankConsignmentItem: ConsignmentItemFormValues = {
  id: null,
  sequenceNumber: 0,
  declarationGoodsItemNumber: 0,
  countryOfDispatch: '',
  countryOfDestination: '',
  referenceNumberUCR: '',
  commodityDescriptionOfGoods: '',
  commodityHarmonizedSystemSubHeadingCode: '',
  commodityCombinedNomenclatureCode: '',
  goodsMeasureGrossMass: 0,
  goodsMeasureNetMass: 0,
  dangerousGoods: [],
  additionalSupplyChainActor: [],
  previousDocument: [],
  supportingDocument: [],
  transportDocument: [],
  additionalReference: [],
  additionalInformation: [],
  packaging: [blankPackaging],
  consignee: blankConsignee,
  deleted: false,
  price: null,
  dutyRate: null,
  dutyAmount: null,
  dutyRateUnit: AmountUnit.PERCENTAGE,
  vatRate: null,
  excise: null,
  initialPrice: null,
  initialPriceCurrency: 'EUR',
  transportEquipment: [],
  containerIndicator: 'false',
  passiveBorderTransportMeans: [],
  differentPassiveBorderTransportMeans: false,
}
export const blankCountryOfRoutingOfConsignment: CountriesOfRoutingType = {
  id: null,
  sequenceNumber: 0,
  country: '',
}
export const blankDangerousGoods: DangerousGoodsType = {
  id: null,
  sequenceNumber: 0,
  unNumber: '',
}
export const blankGoodsReference: GoodsReferenceType = {
  id: null,
  sequenceNumber: 0,
  deleted: false,
  declarationGoodsItemNumber: 0,
  consignmentItemId: null,
}

export const blankHouseConsignmentType: HouseConsignmentFormValues = {
  id: null,
  sequenceNumber: 0,
  grossMass: 0,
  referenceNumberUCR: '',
  securityIndicatorFromExportDeclaration: '',
  transportChargesMethodOfPayment: '',
  consignor: blankConsignor,
  consignee: blankConsignee,
  buyer: blankBuyer,
  seller: blankSeller,
  countryOfDestination: '',
  countryOfDispatch: '',
  additionalSupplyChainActor: [],
  departureTransportMeans: [],
  previousDocument: [],
  supportingDocument: [],
  transportDocument: [],
  additionalReference: [],
  additionalInformation: [],
  consignmentItem: [blankConsignmentItem],
  placeOfAcceptance: blankPlaceOfAcceptance,
  placeOfDelivery: blankPlaceOfDelivery,
  countriesOfRouting: [],
  transportEquipment: [],
  containerIndicator: 'false',
  passiveBorderTransportMeans: [],
  differentBuyer: false,
  differentSeller: false,
  differentCountriesOfRouting: false,
  differentPlaceOfAcceptance: false,
  differentPlaceOfDelivery: false,
}
export const blankPreviousDocument: PreviousDocument = {
  id: null,
  type: 'PREVIOUS',
  sequenceNumber: 0,
  documentType: '',
  referenceNumber: '',
  complementOfInformation: '',
  files: [],
  transportDocumentReferenceNumber: '',
  procedureType: '',
}
export const blankSealType: SealType = {
  id: null,
  sequenceNumber: 0,
  identifier: '',
  deleted: false,
}
export const blankSupportingDocument: SupportingDocument = {
  id: null,
  type: 'SUPPORTING',
  sequenceNumber: 0,
  documentType: '',
  referenceNumber: '',
  complementOfInformation: '',
  files: [],
  documentLineNumber: null,
}

export const blankNotesDocument: NotesDocument = {
  id: null,
  type: 'NOTE',
  sequenceNumber: 0,
  documentType: 'NOTE',
  referenceNumber: '',
  complementOfInformation: '',
  transitOperationId: null,
  files: [],
}

export const blankConsignmentTransportEquipment: TransportEquipmentType = {
  id: null,
  sequenceNumber: 0,
  containerIdentificationNumber: '',
  containerSizeAndType: '',
  supplierType: '',
  packedStatus: '',
  seals: [],
  deleted: false,
  goodsReferences: [],
}

export const blankTransportEquipment: TransportEquipmentType = {
  id: null,
  sequenceNumber: 0,
  containerSizeAndType: '',
  packedStatus: '',
  supplierType: '',
  containerIdentificationNumber: '',
  seals: [],
  goodsReferences: [],
  deleted: false,
}

export const blankItemDepartureTransportMeans: DepartureTransportMeansType = {
  id: null,
  sequenceNumber: 0,
  typeOfIdentification: '',
  identificationNumber: '',
  nationality: '',
  deleted: false,
}

export const blankAuthorisations: AuthorisationFormValues = {
  referenceNumber: '',
  type: '',
  id: null,
  sequenceNumber: 0,
}

export const blankGuarantee: GuaranteeFormValues = {
  id: null,
  deleted: false,
  nctsProfileId: null,
  amount: 0,
  sequenceNumber: 0,
}
